// extracted by mini-css-extract-plugin
module.exports = {"card":"productBoostingRules_card__n6dvb","rulesWrapper":"productBoostingRules_rulesWrapper__MEFxr","rule":"productBoostingRules_rule__y59qD"};